import { Icon } from "@chakra-ui/react"
import { MdError, MdPriorityHigh } from "react-icons/md"

export const ErrorIcon = ({ ...rest }) => (
  <Icon data-testid="error-icon" as={MdError} {...rest} />
)

export const ErrorAlertIcon = ({ ...rest }) => (
  <Icon as={MdPriorityHigh} data-testid="error-alert-icon" {...rest} />
)
